import {request} from "../../../res/rest/restRequest";
import {env} from "../../../res/config/env";
import HttpClient from "../../services/http/HttpClient";
import {api} from "../../../res/rest/api";

const getExistingOrderIDRequest = async (session) => {
    if(!session) return {};
    const req = request.process("getwebcartid")
        .param("c_bpartner_ID", session.bPartnerID)
        .param("ad_org_ID", env.AD_ORG_ID);
    const url = env.API_URL + req.buildRequest();
    const resp = await HttpClient.client.post(url, req.buildRequestBody(), api.auth(session));
    return resp?.data?.data?.cartID;
}

export default getExistingOrderIDRequest;